import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { debounceTime, Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { EnvService } from '../services/env.service';
import { SettingsPersistenceService } from '../services/settings-persistence.service';
import { OsTypeFilter } from './os-type.filter';

@Component({
  selector: 'app-osType',
  templateUrl: './os-type.component.html',
})
export class OsTypeComponent implements OnInit, OnDestroy {
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  pageSettings!: SettingsPersistenceService;
  filter = new OsTypeFilter(this.auth);
  private filterSubscription?: Subscription;

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient) {}

  ngOnInit(): void {
    this.pageSettings = new SettingsPersistenceService(sessionStorage, 'micro.osTypes');
    this.pageSettings.setFilter(this.filter).setPaginator(this.paginator).init();
    this.filterSubscription = this.filter.anyChange.pipe(debounceTime(500)).subscribe(() => {
      this.paginator.pageIndex = 0;
      this.reload();
    });
    this.reload();
  }

  ngOnDestroy(): void {
    this.filterSubscription?.unsubscribe();
    this.pageSettings.removeFilterListener();
    this.pageSettings.removePaginatorListener();
  }

  reload(): void {
    const params: HttpParams = this.filter.getParams()
      .set('page', String(this.paginator.pageIndex || 0))
      .set('size', String(this.paginator.pageSize || 20));

    this.http.get(`${this.env.e.url}/domain/cmdbOsType`, {params}).subscribe(data => {
      const page = data as any;
      this.dataSource.data = page.content;
      this.paginator.pageIndex = page.number;
      this.paginator.pageSize = page.size;
      this.paginator.length = page.totalElements;
    });
  }
}
